import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 13 }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "mt-3 pt-1 d-flex" }
const _hoisted_4 = {
  for: "localization-active",
  class: "d-flex align-items-center cursor-pointer"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "d-block ms-2" }, "Active", -1)
const _hoisted_6 = { id: "icon" }
const _hoisted_7 = { class: "w-100 d-flex flex-column justify-content-center" }
const _hoisted_8 = { class: "pt-5 d-flex justify-content-center align-items-center" }

import { computed, nextTick, Ref, ref, watch } from "vue";
import AppCheckbox from "@/components/Form/AppCheckbox.vue";
import TabsDialog from "@/components/ui/Modal/Dialog/TabsDialog.vue";
import { api } from "@/api/Api";
import AppInputsValidationProvider from "../Form/AppInputsValidationProvider.vue";
import AppInput from "../Form/AppInput.vue";
import AppButton from "../ui/Buttons/AppButton.vue";
import AvatarUpload from "@/components/ui/AvatarUpload.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateLocalizationModal',
  props: {
    windowLoading: { type: Boolean },
    actionLoading: { type: Boolean },
    opened: { type: Boolean },
    localization: null
  },
  emits: {
  hide: null,
  setLocalization: null,
  save: null,
  setModalLoading: null,
  updateIcon: null
},
  setup(__props: any, { emit }) {

const props = __props as {
  windowLoading: boolean;
  actionLoading: boolean;
  opened: boolean;
  localization: editLocalizationData;
};


const currentLocalization = ref({ ...props.localization });

watch(
  () => props.localization,
  () => {
    currentLocalization.value = { ...props.localization };
  },
  { deep: true, immediate: true }
);



// Validation
const titleValid = ref(!!props.localization?.short_name);
const valid = computed(() => !!titleValid.value);
const shakeTree = ref(false);

// Summary
const action = computed(() =>
  props.localization?.short_name ? "edit" : "create"
);

// UI
const localOpened = ref(props.opened);
watch(
  () => props.opened,
  opened => {
    localOpened.value = opened;
  },
  { immediate: true }
);

const tabs = ["Details", "Icon"].map((tab, idx) => ({
  title: tab,
  id: idx
}));

const selectedTab = ref(0);

const modalTitle = computed(() => {
  return props.localization?.full_name || `New Localization`;
});

const buttonText = computed(() => {
  const type = action.value === "create" ? "New" : "Edit";
  return `${type} Localization`;
});

const locationsSelectOpened = ref(false);

// Actions
const hide = () => emit("hide");

function changeValidationStatus(error: boolean) {
  titleValid.value = !error;
}

async function setImage(type: locationImageVariants, image: File) {
  if (!image) {
    currentLocation.value.icon = "";
    return;
  }

  emit("setModalLoading", true);

  const { data } = await api.uploadLocalizationImage({
    image
  });

  data && (currentLocalization.value.icon = data.url);
  emit(
    "updateIcon",
    action.value,
    {
      short_name: currentLocalization.value.short_name,
      active: currentLocalization.value.active,
      icon: currentLocalization.value.icon,
      full_name: currentLocalization.value.full_name
    },
    currentLocalization.value,
    props.localization?.id
  );
  emit("setModalLoading", false);
}

async function submitHandler() {
//   emit("setLocalization", currentLocalization.value);
  emit(
    "save",
    action.value,
    {
      short_name: currentLocalization.value.short_name,
      active: currentLocalization.value.active,
      icon: currentLocalization.value.icon,
      full_name: currentLocalization.value.full_name
    },
    props.localization?.id
  );
}

// function toggleSelectedLocalization(localization: switchedLocalization) {
//   emit("toggleSelectedLocalization", localization);
// }

function toggleSelectedLocalization(open?: boolean) {
  if (open) {
    localOpened.value = !open;
    nextTick(() => {
      localizationSelectOpened.value = localizationSelectOpened.value =
        open ?? false;
    });
  } else {
    localizationSelectOpened.value = localizationSelectOpened.value =
      open ?? false;

    nextTick(() => {
      localOpened.value = !open;
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TabsDialog, {
    key: 1,
    modelValue: selectedTab.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedTab).value = $event)),
    tabs: _unref(tabs),
    opened: localOpened.value,
    "modal-loading": __props.windowLoading,
    title: _unref(modalTitle),
    class: "create-location-modal",
    onHide: hide
  }, {
    "modal-button": _withCtx(() => [
      _createVNode(AppButton, {
        type: "secondary",
        disabled: !_unref(valid),
        loading: __props.actionLoading,
        size: "xl",
        onClick: submitHandler
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ]),
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.opened)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "mt-5",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
            }, [
              (_openBlock(), _createBlock(AppInputsValidationProvider, {
                key: 13,
                "shake-tree": shakeTree.value,
                onChangeErrorState: changeValidationStatus
              }, {
                default: _withCtx(() => [
                  _createVNode(AppInput, {
                    id: "localization-full-name",
                    modelValue: currentLocalization.value.full_name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentLocalization.value.full_name) = $event)),
                    "input-type": "material",
                    label: "Full name",
                    "validation-type": "notEmptyString"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(AppInput, {
                      id: "short-name",
                      modelValue: currentLocalization.value.short_name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentLocalization.value.short_name) = $event)),
                      label: "Short name",
                      "input-type": "material",
                      "validation-type": "notEmptyString"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["shake-tree"])),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(AppCheckbox, {
                    id: "localization-active",
                    modelValue: currentLocalization.value.active,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentLocalization.value.active) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_5
                ])
              ])
            ], 32))
          : _createCommentVNode("", true)
      ])),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(AvatarUpload, {
              size: "60x60",
              format: "PNG",
              title: `Please, upload Localization Icon.`,
              direction: "column",
              placeholder: __props.localization?.icon,
              onFileChanged: _cache[4] || (_cache[4] = 
              file => {
                setImage('icon', file);
              }
            )
            }, null, 8, ["title", "placeholder"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "tabs", "opened", "modal-loading", "title"]))
}
}

})